import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react"
import {useAppToast} from "@ui-seeker/app";
import {getSubmit} from "@ui-seeker/utils"

import {BACKEND_APIS} from "@constants"
import {repricingNotificationsType, repricingIsLoadingNotifications, repricingAlertsClicked} from "../../@signals";


export default function useRepricingNotifications() {
	const { showToast } = useAppToast()
	const notifications = useSignal([])

	useEffect(() => {
		repricingIsLoadingNotifications.value = true
		getSubmit(`${BACKEND_APIS.REPRICING}/notifications/list`, {
			notificationType: repricingNotificationsType.value,
			rulesID: repricingAlertsClicked.value
		}).then(res => batch(() => notifications.value = res.notification))
			.catch(() => showToast.error())
			.finally(() => repricingIsLoadingNotifications.value = false)
	}, [repricingNotificationsType.value, JSON.stringify(repricingAlertsClicked.value)])

	return {
		notifications: notifications.value,
	}
}